import { IReduxState } from 'types/redux';

export const zonesMapSelector = (state: IReduxState) => state.zones.map;
